import React from 'react'
import styled from 'styled-components'
import useShop from '../context/AppContext'
import { Helmet } from 'react-helmet'
import { motion } from 'framer-motion'
import { Layout } from '../layout'

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  min-height: calc(100dvh - 100px);
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 86%;
  max-width: var(--max-width);
  padding: 150px 0;
  margin: 0 auto;
  h1 {
    margin-bottom: 15px;
  }
  p {
    font-size: var(--fz-lg);
    color: var(--text);
    line-height: 1.5;
    font-weight: 400;
    margin-bottom: 50px;
    text-align: center;
  }
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: calc(100% - 50px);
    margin: 0 25px;
  }
`

const Error = () => {
  const { preloaderExecuted, navigationExecuted } = useShop()
  const data = 'Page not found'
  const desc = 'If you are seeing this page, it means that the page you are looking for does not exist or an error has occurred.'

  return (
    <Layout>
      <Helmet>
        <title>Robert Eberhard – Shopify Design and Development</title>
      </Helmet>
      <SectionWrapper>
        {preloaderExecuted && navigationExecuted ? (
          <SectionContainer>
            <motion.div animate={{ y: [30, 0], opacity: [0, 1] }} transition={{ delay: 0, duration: 0.5 }} className="start-opacity">
              <h1>{data}</h1>
            </motion.div>
            <motion.div animate={{ y: [30, 0], opacity: [0, 1] }} transition={{ delay: 0.2, duration: 0.5 }} className="start-opacity">
              <p>{desc}</p>
            </motion.div>
          </SectionContainer>
        ) : (
          <SectionContainer>
            <motion.div animate={{ y: [30, 0], opacity: [0, 1] }} transition={{ delay: 0.5, duration: 0.5 }} className="start-opacity">
              <h1>{data}</h1>
            </motion.div>
            <motion.div animate={{ y: [30, 0], opacity: [0, 1] }} transition={{ delay: 0.5, duration: 0.5 }} className="start-opacity">
              <p>{desc}</p>
            </motion.div>
          </SectionContainer>
        )}
      </SectionWrapper>
    </Layout>
  )
}

export default Error
